// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__8DsbS","main":"index_main__3Wsn6","collapseContent":"index_collapseContent__wW1f8"};